<template>
  <v-container
    style="background: #e8effc;"
    class="pt-0 pb-0 pl-3 pr-3"
  >
    <v-row>
      <v-col class="d-flex align-center">
        <p
          class="ma-0"
          style="color: #5593ad; font-size: 14px;"
        >
          {{ (selected.length > 1) ? selected.length + ' items' : selected.length + ' item' }} selected
        </p>
      </v-col>
      <v-col
        v-if="multiActions.length"
        md="3"
      >
        <v-select
          v-model="selectedAction"
          label="Bulk Actions"
          class="bulk-actions-select"
          :background-color="'white'"
          :items="multiActions"
          return-object
          solo
          dense
          hide-details
        />
      </v-col>
      <v-col
        v-if="multiActions.length"
        md="2"
      >
        <v-btn
          color="primary"
          style="min-width: 120px;"
          :disabled="!selectedAction || !validItems"
          depressed
          tile
          @click="performBulkAction()"
        >
          Submit
        </v-btn>
        <v-tooltip
          v-if="selectedAction && !validItems"
          bottom
        >
          <template #activator="{ on }">
            <v-icon v-on="on">
              help
            </v-icon>
          </template>
          <p
            class="mb-0"
            style="max-width: 250px"
          >
            Some selected items cannot have this action performed on them, either you don't have permission to act on them or their current state prevents this action.
          </p>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    type: { type: String, default: () => null },
    selected: { type: Array, required: true },
    api: { type: String, required: true },
    updateResults: { type: Function, required: true },
    multiActions: { type: Array, default: () => [] }
  },
  data() {
    return {
      selectedAction: null,
      validItems: false,
      reinstateCorrective: [
        {
          text: 'Reinstate',
          value: 'reinstate-corrective'
        },
        {
          text: 'Disable',
          value: 'disable-corrective'
        }
      ],
      availableProviderActions: [
        {
          text: 'Purge Old Documents',
          value: 'purge-job'
        },
        {
          text: 'Remove',
          value: 'remove-job'
        }
      ],
      availableCustomerActions: [
        {
          text: 'Disable',
          value: 'disable-customer'
        },
        {
          text: 'Enable',
          value: 'enable-customer'
        }
      ],
      availableUserActions: [
        {
          text: 'Remove',
          value: 'remove-user'
        }
      ]
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.user.isSuper
    },
    items() {
      switch (this.type) {
        case 'provider': return this.isAdmin ? this.availableProviderActions : []
        case 'corrective': return this.isAdmin ? this.reinstateCorrective : []
        case 'customer': return this.isAdmin ? this.availableCustomerActions : []
        case 'user': return this.isAdmin ? this.availableUserActions : []
        default: return []
      }
    }
  },
  watch: {
    selected: {
      immediate: true,
      deep: true,
      handler(val) {
        this.updateItemValidity(val)
      }
    },
    selectedAction: {
      deep: true,
      handler() {
        this.updateItemValidity()
      }
    }
  },
  methods: {
    async performBulkAction() {
      await this.selectedAction.method([...this.selected])
      this.updateResults()
    },
    updateItemValidity(items) {
      let selected = items
      if (!items) {
        selected = this.selected
      }
      if (!this.selectedAction) {
        this.validItems = false
      } else if (!this.selectedAction.enabled) {
        this.validItems = true
      } else {
        this.validItems = selected.every(item => this.selectedAction.enabled(item))
      }
    }
  }
}
</script>
<style scoped>

  .bulk-actions-select .v-input__control .v-input__slot {
    min-height: 36px !important;
  }

  .bulk-actions-select .v-input__control {
    min-height: 36px !important;
  }
</style>
